module.exports = __webpack_public_path__ + "static/media/Poppins-RegularItalic-devanagari.ba7c820d.woff2";